import { FacebookPageDataBuilder } from './facebook-page-data-builder';
import { PluginType } from './plugin-type.enum';
var FacebookPagePluginBuilder = /** @class */ (function () {
    function FacebookPagePluginBuilder() {
        this.facebookPlugin = {
            externalKey: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            name: 'bobi',
            creationDate: Date.now(),
            lastUpdateDate: Date.now(),
            type: PluginType.FACEBOOK_PAGE,
            data: new FacebookPageDataBuilder().build()
        };
    }
    FacebookPagePluginBuilder.prototype.withExternalKey = function (externalKey) {
        this.facebookPlugin.externalKey = externalKey;
        return this;
    };
    FacebookPagePluginBuilder.prototype.withName = function (name) {
        this.facebookPlugin.name = name;
        return this;
    };
    FacebookPagePluginBuilder.prototype.withCreationDate = function (date) {
        this.facebookPlugin.creationDate = date;
        return this;
    };
    FacebookPagePluginBuilder.prototype.withLastUpdateDate = function (date) {
        this.facebookPlugin.lastUpdateDate = date;
        return this;
    };
    FacebookPagePluginBuilder.prototype.withType = function (type) {
        this.facebookPlugin.type = type;
        return this;
    };
    FacebookPagePluginBuilder.prototype.withData = function (data) {
        this.facebookPlugin.data = data;
        return this;
    };
    FacebookPagePluginBuilder.prototype.build = function () {
        return this.facebookPlugin;
    };
    return FacebookPagePluginBuilder;
}());
export { FacebookPagePluginBuilder };
;
//# sourceMappingURL=facebook-page-plugin-builder.js.map